import React from "react";
import { Controller, useForm } from "react-hook-form";
import {
  LeadAssignmentSettings,
  AccountType,
} from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { Multiselect } from "react-widgets";
import { CompanyAssigneeSettings, convertPascalCaseToWords } from "../../../../core";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: CompanyAssigneeSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: CompanyAssigneeSettings;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<CompanyAssigneeSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderCompanyAssigneeTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Company Assignee Types<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="assigneeTypes"
                defaultValue={props.data?.assigneeTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "BusinessDeveloperExecutive" : key === "Agent" ?
                            "TransactionExecutive" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select Company Assignee Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.assigneeTypes && (
                <ErrorMessage>Company Assignee Types is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Company Assignee Settings
        </h4>
        <div className="row gutter-10">
          {renderCompanyAssigneeTypes()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
